import { Helmet } from 'react-helmet-async';

function PageMetadata ({
    title,
    description,
    canonical,
    og = {},
    schema
}) {
    return (
        <Helmet>
            {/* Basic SEO */}
            {title && <title>{title}</title>}
            {description && (
                <meta name="description" content={description} />
            )}
            {canonical && (
                <link rel="canonical" href={canonical} />
            )}

            {/* Open Graph */}
            {og.title && (
                <meta property="og:title" content={og.title} />
            )}
            {og.description && (
                <meta property="og:description" content={og.description} />
            )}
            {og.url && (
                <meta property="og:url" content={og.url} />
            )}
            {og.type && (
                <meta property="og:type" content={og.type} />
            )}

            {/* Schema */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default PageMetadata;